import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SafeHtmlPipe} from './safe-html/safe-html.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  exports: []
})
export class PipesModule {
}



// WEBPACK FOOTER //
// /app/src/app/pipes/pipes.module.ts